import HttpClient from "./http-client";
import { Cookies } from 'react-cookie';
import { SIGN_UP_VERIFICATION, CREATE_WALL, MediaBaseUrl } from './api'
import { USER_TOKEN, USER_AUTHENTICATED_LOGIN, UPDATE_FIRST_RUN } from '../reducers/keys';
import { TOAST_ERROR, encrypt, updateUserToken, withSkipOnboarding } from '../utils';
import { getIPDetails, getUpdatedExtraData } from "./loginActions";
import { getWidgetWallData } from "./wallDataAction";
import { SHOW_DEMO_POST } from "./wallsAction";
const cookies = new Cookies();

const products = [
    {
        id: 6,
        title: "For Digital Marketers",
        productImg: `${MediaBaseUrl}products/taggbox-init.png`,
        tags: ["Website", "Email Campaign"],
        content: "Collect and publish social content, UGC and review feeds on your website.",
        competetors: "EmbedSocial, Curator.io, Juicer etc",
        buttonText: "Continue With Tagbox"
    },
    {
        id: 4,
        title: "For Events Marketers",
        productImg: `${MediaBaseUrl}products/socialwall-init.png`,
        tags: ["Event Displays", "DooH Ads", "Signage"],
        content: "Curate social walls featuring engaging social content for your events.",
        competetors: "Walls.io, Everwall",
        buttonText: "Continue With Social walls"
    }
]

export const getInItProduct = (product_type) => {
    if (product_type == null) return products;
    const arrayproduct = [];
    arrayproduct.push({ id: 4, name: 'Create Social Wall', url: `${MediaBaseUrl}icons/svg-icons/create-wall.svg` });
    arrayproduct.push({ id: 4, name: 'Event / Virtual Event / Hybrid Events', url: `${MediaBaseUrl}icons/svg-icons/event.svg` });
    arrayproduct.push({ id: 4, name: 'In-store Display / DoohAds/Digital Displays', url: `${MediaBaseUrl}icons/svg-icons/display.svg` });
    return arrayproduct;
}

export const selectProduct = (postbody, history, callback = () => { }) => {
    const { productId, productName } = postbody;
    let data = { productId };
    return async (dispatch) => {
        await getIPDetails().then(ipResponse => {
            if (ipResponse && ipResponse.data && Object.keys(ipResponse.data).length > 0) {
                data = { ...data, countryCode: ipResponse.data.country }
            }
        }).catch(ex => console.log("error"));
        callback();
        setTimeout(() => {
            const authToken = localStorage.getItem('authToken')
            localStorage.removeItem('authToken');
            if (authToken) localStorage.setItem('access_token', authToken);
            history(`/onboarding`);
        }, 1000);


    }
}


export const signUpVerified = (country = "", token, history, setCookie, emitSocket, guestId) => {

    return async (dispatch) => {

        new HttpClient().post(`${SIGN_UP_VERIFICATION}/${token}`, country).then(async (response) => {
            const { responseData, responseMessage } = response.data || {};

            if (!responseData?.token) {
                TOAST_ERROR(responseMessage || "Email verification failed, please try again.");
                setTimeout(() => {
                    history("/accounts/login")
                }, 1000);
                return;
            }

            dispatch({ type: USER_TOKEN, payload: responseData });
            localStorage.removeItem('authToken');
            localStorage.setItem('access_token', responseData.token);

            const user = responseData?.user;

            // ownerId / loginOwnerId / isCollaborator headers createWall se pehle set hone chahiye
            if (user && Object.keys(user).length > 0) {
                localStorage.setItem('ownerId', user.ownerId);
                localStorage.setItem('loginOwnerId', user.userhashId);
                localStorage.setItem('isCollaborator', 0);
            }

            let payload = { socialWall: 1 };
            if (guestId && guestId.length > 0) {
                const signUpData = guestId.split('_');
                if (signUpData.length == 2) {
                    const [userToken, themeId] = signUpData;
                    payload = { ...payload, referenceId: userToken, themeId: themeId };
                }
            }

            let wall = null;
            try {
                const wallResponse = await new HttpClient().post(`${CREATE_WALL}`, payload);
                wall = wallResponse?.data?.responseData;
            } catch (ex) {
                // wall na bane to bhi user ko login karake aage bhejna hai, loader pe atkana nahi hai
                console.log("createWall failed :", ex?.response?.data?.responseMessage || ex?.message);
            }

            // website (guest) user ko onboarding nahi dikhana hai
            if (guestId && user && Object.keys(user).length > 0) {
                user.extra_data = withSkipOnboarding(user.extra_data);
                localStorage.setItem('isOnboarding', 1);
            }

            localStorage.setItem('user_data', encrypt(JSON.stringify(responseData)));
            setCookie();

            if (user && Object.keys(user).length > 0) {
                let d = new Date();
                d.setTime(d.getTime() + (86400 * 30));
                cookies.set("memberLogin", true, { path: "/", expires: d, domain: '.taggbox.com' });
                cookies.set("memberUserId", user.id, { path: "/", expires: d, domain: '.taggbox.com' });
            }

            dispatch({ type: USER_TOKEN, payload: responseData.token });
            dispatch({ type: USER_AUTHENTICATED_LOGIN, payload: responseData });

            const wallId = wall?.wallId;
            if (wallId) {
                let data = { ...responseData };
                if (data.user) data['user']['wallIdDesc'] = wallId;
                localStorage.setItem('user_data', encrypt(JSON.stringify(data)));
                localStorage.setItem('wallId', wallId);
                dispatch(getWidgetWallData(user?.ownerId, wallId)).then(() => {
                    SHOW_DEMO_POST(1, wallId);
                }).catch(ex => console.log(ex));
            }

            if (guestId) {
                dispatch(getUpdatedExtraData({ skip_onboarding: true }));
            }

            const redirect = () => {
                // pehle navigate, phir firstRun - taaki app ki initial calls (details / feeds /
                // notification / plan) sahi route aur naye token ke saath hi chalein
                history(guestId ? "/walls/home" : "/onboarding");
                dispatch({ type: UPDATE_FIRST_RUN, payload: true });

                // socket ka 'update' event server pe userInfo se naya token banwata hai. Agar ye
                // initial calls ke beech me ho jaye to purane token wali requests 419 de deti hain,
                // isliye emit sabse aakhir me karo.
                if (user && Object.keys(user).length > 0) {
                    setTimeout(() => {
                        try { emitSocket(user.id); } catch (ex) { console.log(ex); }
                    }, 2000);
                }
            }

            setTimeout(redirect, 1000);
        }).catch(ex => {
            const { responseMessage, responseCode } = ex?.response?.data || {};
            if (responseCode == 401 || ex?.response?.status == 401) {
                setTimeout(() => {
                    localStorage.clear();
                    history("/accounts/login")
                }, 1000)
            }
            TOAST_ERROR(responseMessage || "Something went wrong, please try again.");
        })
    }
}

export const createWall = (productName = null) => {
    return new HttpClient().post(`${CREATE_WALL}`, {
        socialWall: 1
    });
}